import React from 'react';
import { Button } from '@/app/components/ui/button';
import { Input } from '@/app/components/ui/input';
import { Label } from '@/app/components/ui/label';
import { useLanguage } from '@/app/contexts/LanguageContext';

interface ConnectionDialogProps {
  isOpen: boolean;
  label: string;
  onLabelChange: (label: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConnectionDialog({
  isOpen,
  label,
  onLabelChange,
  onConfirm,
  onCancel,
}: ConnectionDialogProps) {
  const { t } = useLanguage();
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-lg shadow-xl p-6 w-96"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'var(--md-surface-container)',
          color: 'var(--md-on-surface)',
        }}
      >
        <h2 className="text-xl font-semibold mb-4">{t('dialogs.connection.title')}</h2>

        <div className="space-y-4">
          {/* Label Input */}
          <div>
            <Label htmlFor="connection-label">{t('dialogs.connection.label')}</Label>
            <Input
              id="connection-label"
              type="text"
              value={label}
              onChange={(e) => onLabelChange(e.target.value)}
              placeholder={t('dialogs.connection.placeholder')}
              className="mt-1"
              autoFocus
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-2 mt-6">
          <Button onClick={onCancel} variant="outline" className="flex-1">
            {t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} className="flex-1">
            {t('common.create')}
          </Button>
        </div>
      </div>
    </div>
  );
}